<template>
  <div>
    <v-menu offset-y :close-on-click="false">
      <template v-slot:activator="{ on }">
        <v-btn @click="clicked()" v-on="on" v-bind="$props">
          <!-- Pass on all named slots -->
          <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

          <!-- Pass on all scoped slots -->
          <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
        </v-btn>
      </template>
      <v-alert dense color="lime" class="alert">
        <div class="content">{{ message }}</div>
        <div class="btn-container">
          <v-btn color="grey lighten-1" small fab class="no">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn color="black" small fab @click="yes()" class="ok">
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </div>
      </v-alert>
    </v-menu>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "ConfirmButton",
  props: {
    value: {
      default: false,
    },
    message: {
      default: "Please confirm !",
    },
    color: {
      type: String,
      default: undefined,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ConfirmButton extends (Vue, Themeable) {
  clicked() {
    this.confirm = true;
  }

  yes() {
    this.$emit("click");
  }
}
</script>

<style scoped>
.content {
  padding: 5px 120px 5px 5px;
  font-weight: 400;
  display: table-cell;
  vertical-align: middle;
}

.no {
  position: absolute;
  bottom: 5px;
  right: 40px;
}

.ok {
  position: absolute;
  bottom: 5px;
  right: -10px;
}
.btn-container {
  float: right;
  align-items: center;
  height: 100%;
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.alert {
  margin-bottom: 0;
  padding: 5px;
  max-width: 400px;
  min-height: 55px;
}
</style>
